'use client';

import { getFragmentData } from '@/__generated__';
import { ENTRY_BASE_FRAGMENT } from '@/gql/fragments/entries.gql';
import { VENUE_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { useColorScheme } from '@/lib/parsers/common';
import { useBreakpointMin } from '@/theme';
import { withFragment } from '@liquorice/gql-utils';
import { firstNonNullable } from '@liquorice/utils';
import Breadcrumbs from '../Breadcrumbs';
import ColorMask from '../Image/Color.Mask';
import Grid from '../ui/Grid';
import PageHeaderRoot from './PageHeaderRoot';
import PageImage from './PageImage';
import PageTitle from './PageTitle';

const PageHeaderVenue = withFragment(VENUE_CARD_FRAGMENT, (data) => {
  const base = getFragmentData(ENTRY_BASE_FRAGMENT, data);
  const sm = useBreakpointMin('sm');

  if (!data) return null;

  const { colorScheme, oppositeScheme } = useColorScheme(data.colorScheme);

  return (
    <PageHeaderRoot
      variant="overview"
      colorSet={colorScheme}
      paper
      GridColProps={{ md: 8 }}
      afterCol={
        sm && (
          <Grid.Col offsetMd={1} sm={5} md={3}>
            {!!firstNonNullable(data.entryImage) ? (
              <PageImage mask={true} data={data.entryImage} />
            ) : (
              <ColorMask color={colorScheme} />
            )}
          </Grid.Col>
        )
      }>
      <Breadcrumbs
        data={base}
        CtaButtonProps={{ color: oppositeScheme }}
        cx={{ mB: 'xs', mT: '5xl' }}
      />
      <PageTitle uppercase cx={{ mB: '5xl' }}>
        {data.entryTitle}
      </PageTitle>
    </PageHeaderRoot>
  );
});

export default PageHeaderVenue;
